/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as r } from "./maybe.js";

function n(r, n) {
  if (r.forEach) r.forEach(n);else for (var _t = 0; _t < r.length; _t++) {
    n(r[_t], _t, r);
  }
}

function t(r, n, t) {
  if (r.slice) return r.slice(n, t);
  void 0 === n ? n = 0 : (n < 0 && (n += r.length), n = Math.min(r.length, Math.max(0, n))), void 0 === t ? t = r.length : (t < 0 && (t += r.length), t = Math.min(r.length, Math.max(0, t)));
  var o = Math.max(0, t - n),
      c = new (0, r.constructor)(o);

  for (var _e = 0; _e < o; _e++) {
    c[_e] = r[n + _e];
  }

  return c;
}

function o(r) {
  return r instanceof ArrayBuffer || r && r.constructor && "ArrayBuffer" === r.constructor.name;
}

function c(r) {
  return r instanceof Int8Array || r && r.constructor && "Int8Array" === r.constructor.name;
}

function e(r) {
  return r instanceof Uint8Array || r && r.constructor && "Uint8Array" === r.constructor.name;
}

function a(r) {
  return r instanceof Uint8ClampedArray || r && r.constructor && "Uint8ClampedArray" === r.constructor.name;
}

function u(r) {
  return r instanceof Int16Array || r && r.constructor && "Int16Array" === r.constructor.name;
}

function i(r) {
  return r instanceof Uint16Array || r && r.constructor && "Uint16Array" === r.constructor.name;
}

function f(r) {
  return r instanceof Int32Array || r && r.constructor && "Int32Array" === r.constructor.name;
}

function s(r) {
  return r instanceof Uint32Array || r && r.constructor && "Uint32Array" === r.constructor.name;
}

function y(r) {
  return r instanceof Float32Array || r && r.constructor && "Float32Array" === r.constructor.name;
}

function A(r) {
  return r instanceof Float64Array || r && r.constructor && "Float64Array" === r.constructor.name;
}

function l(r) {
  var n = new Array(r.length);

  for (var _t2 = 0; _t2 < r.length; _t2++) {
    n[_t2] = r[_t2];
  }

  return n;
}

function m(n) {
  return r(n) ? 0 : 128 + n.buffer.byteLength + 64;
}

export { m as estimateSize, n as forEach, o as isArrayBuffer, y as isFloat32Array, A as isFloat64Array, u as isInt16Array, f as isInt32Array, c as isInt8Array, i as isUint16Array, s as isUint32Array, e as isUint8Array, a as isUint8ClampedArray, t as slice, l as toArray };